import { MarcacaoConsultaPK } from "../marcacao/marcacao-consulta/pks/marcacao-consulta-pk";
import { InformacaoCancelamentoMarcacaoDTO } from "./informacao-cancelamento-marcacao-dto";

export class InformacaoCancelamentoMarcacaoConsultaDTO extends InformacaoCancelamentoMarcacaoDTO {

    pkMarcacao: MarcacaoConsultaPK | undefined;

}
